import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Route, useLocation } from "react-router-dom";
import { SecureRoute, useOktaAuth } from "@okta/okta-react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setMyUserInfo, setUserInfo } from "../app/store/slices/user/effects";
import UserByStoreRepository from "../repositories/userByStore";
import LoginRepository from "../repositories/login";
import OneSignal from "react-onesignal";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  path,
  ...rest
}) => {
  return isAuthProtected ? (
    <SecureRoute path={path} component={Component} {...rest} />
  ) : (
    <Route path={path} component={Component} {...rest} />
  );
};

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
};

export default Authmiddleware;

export const ContentRoute = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const info = useSelector(state => state.userAuth.userInfoFromApi)

  let isAuthenticated = authState?.isAuthenticated;

  useEffect(() => {
    if (typeof window !== "undefined") {
      OneSignal.init({
        appId: process.env.REACT_APP_ONE_SIGNAL_ID,
        notifyButton: {
          enable: true,
        },
        allowLocalhostAsSecureOrigin: true,
      });
    }
    //OneSignal.setExternalUserId(info?.id);
    OneSignal.User.addTags({
      role: info?.role,
    });
  }, [info]);

  useEffect(() => {
    const fetchUser = async () => {
      if (isAuthenticated && authState?.accessToken) {
        try {
          const token = oktaAuth.getAccessToken();
          if (!token) {
            console.error("No se encontró un token de acceso.");
            return;
          }
          const user = await oktaAuth.getUser();

          const loginRepo = new LoginRepository();
          loginRepo.setToken(token);
          loginRepo.setMaycaToken(token);

          const repo = new UserByStoreRepository();
          await repo.checkValidity();

          dispatch(setUserInfo(user));
          dispatch(setMyUserInfo());

          const url =
            location.pathname === "/login" ? "/dashboard" : location.pathname;
          history.push(url);
        } catch (error) {
          console.error("Error en la autenticación:", error);
        }
      } 
    };

    fetchUser();
  }, [isAuthenticated, authState]);

  return <>{children}</>;
};
